export const PROXY_URL =
  "https://app.perpetua.io/api/proxy?url=";

export const prepareURLWithCORS = (url: string) => {
  return PROXY_URL + url;
};
